import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import UsersSummary from '@justgiving/users-summary';
import '@justgiving/users-summary/src/UsersSummary.scss';
import { Track } from '@justgiving/react-tracking';
import gql from 'graphql-tag';

import PATHS from '../../constants/paths';
import './MembersMini.scss';
import { MembersMiniFragment } from '../../../types/__generated__';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../hooks/usePageQuery';
import { SIZE_136_136 } from '../../constants/imageTemplateStrings';

const FRAGMENT = buildQuery(gql`
  fragment MembersMini on Page {
    legacyId
    membershipPolicy
    relationships {
      members(first: 3) {
        totalCount
        nodes {
          ... on Page {
            owner {
              avatar
            }
            id
          }
        }
      }
    }
  }
`);

const MembersMini: FunctionComponent = () => {
  const result = usePageQuery<MembersMiniFragment>(FRAGMENT);

  if (!UsePageQueryResult.hasData(result)) {
    return null;
  }

  const { relationships, membershipPolicy, legacyId } = result.data;

  const members = relationships && relationships.members;
  const membersCount = (members && members.totalCount) || 0;

  const membersList =
    (members &&
      members.nodes.map(member => ({
        id: member.id,
        picture:
          (member.owner?.avatar &&
            `${member.owner.avatar}?template=${SIZE_136_136}`) ||
          undefined,
      }))) ||
    [];

  return (
    <UsersSummary usersList={membersList} avatarSize="medium" hasBorder>
      <div className="jg-space-mlxs jg-pages-membersmini-content jg-text--regular">
        <span className="jg-pages-membersmini-label">
          <Trans i18nKey="team.userLabel" count={membersCount}>
            {{ count: membersCount }} team member
          </Trans>
        </span>
        {membershipPolicy === 'open' && (
          <Track>
            {track => (
              <a
                onClick={() =>
                  track({
                    action_name: 'link click',
                    event_value: 'join the team',
                    sub_section: 'top',
                  })
                }
                className="jg-pages-membersmini-link"
                href={`${PATHS.JOIN_URL}${legacyId}`}
              >
                <Trans i18nKey="members.join">Join the team</Trans>
              </a>
            )}
          </Track>
        )}
      </div>
    </UsersSummary>
  );
};

export default MembersMini;
